import { AgxApi } from '../../helpers/http';

export const docusignApi = (authToken: string) => new AgxApi('docusign', authToken);

export const resendEnvelope = async (
  authToken: string,
  envelopeId: string,
  recipientId: string
) => {
  try {
    const { data } = await docusignApi(authToken).post<boolean>('ResendEnvelope', {
      envelopeId,
      recipientId,
    });

    return data;
  } catch (err) {
    console.error(err);
  }

  return false;
};
